import { AlarmModel } from '@/flightpath-components/models/AlarmModel';
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { orderBy } from 'lodash';
@Module({ name: 'alarm' })
export default class AlarmStore extends VuexModule {
  alarmCount = 0;
  alarms: Array<AlarmModel> = [];

  @Mutation
  changeAlarms(alarms: Array<AlarmModel>) {
    this.alarms = orderBy(alarms, ['AlarmTime'], ['desc']);
    this.alarmCount = alarms.filter(value => {
      return value.Active == true && value.Acknowledged == false;
    }).length;
  }
  get currentAlarmCount(): number {
    return this.alarmCount;
  }
  get currentAlarms(): Array<AlarmModel> {
    return this.alarms;
  }
}
